<!--
 * @Author: Tang Hao
 * @Date: 2024-07-05 15:51:51
 * @LastEditors: Tang Hao
 * @LastEditTime: 2025-04-07 16:46:45
 * @Description:
-->
<script>
import TablePage from '@/found/components/table_page';
import request from '@/found/utils/request';
import FinancialStatistics from './form/financial_statistics.vue';

export default {
  extends: TablePage,
  components: {
    // Form,
    FinancialStatistics,
  },
  data() {
    return {
      // requestType: 'POST',
    };
  },
  mounted() {
    this.getConfigList('cps_financial_audit_list');
  },
  methods: {
    modalClick({ val, row }) {
      if (val.code === 'financial_statistics') {
        // this.formConfig = {
        //   ...this.formConfig,
        //   code: val.code,
        //   row,
        // };
        // this.modalConfig.title = '统计数据';
        // this.formName = 'FinancialStatistics';
        // this.openFull();
        request.post('/tax/v1/tax/report/genStatData').then((response) => {
          const { success, message } = response;
          if (success) {
            this.$message.success(message);
            this.getList();
          }
        });
      }
    },
  },
};
</script>
